"use client";

import { Alert, Snackbar } from "@mui/material";
import { useSearchParams } from "next/navigation";
import { useEffect, useState } from "react";

interface NotificationProps {
  message?: string;
  severity?: "success" | "error" | "warning" | "info";
  duration?: number;
}

const Notification: React.FC<NotificationProps> = ({ 
  message, 
  severity = "success", 
  duration = 6000 
}) => {
  const [open, setOpen] = useState(false);
  const searchParams = useSearchParams();

  useEffect(() => {
    const messageParam = searchParams.get("message");
    if (messageParam) {
      setOpen(true);
      // Clean up URL parameter
      const url = new URL(window.location.href);
      url.searchParams.delete("message");
      window.history.replaceState({}, "", url.toString());
    }
  }, [searchParams]);

  const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const getMessageText = () => {
    if (message) return message;
    
    const messageParam = searchParams.get("message");
    switch (messageParam) {
      case "password-reset-success":
        return "Password reset successful! You can now login with your new password.";
      case "password-reset-email-sent":
        return "Password reset email sent. Please check your inbox.";
      default:
        return messageParam || "";
    }
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={duration}
      onClose={handleClose}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
    >
      <Alert
        onClose={handleClose}
        severity={severity}
        sx={{ width: "100%" }}
        variant="filled"
      >
        {getMessageText()}
      </Alert>
    </Snackbar>
  );
};

export default Notification;
